import { colorsPalettes } from "@similarweb/styles";
import { Box, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import type { Contact } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";
import { ContactCard } from "app/pages/sales-intelligence/pages/ai-agent/components/ContactCard/ContactCard";

import { StyledContactCardsContainer } from "./styles";

type Props = {
    onSelect: (contact: Contact) => void;
    value: Contact[];
    isDisabled: boolean;
    isLoading: boolean;
    isLimitReached: boolean;
    highlightedContactId?: string;
    onHighlightEnd: () => void;
};

export const ContactCards = ({
    onSelect,
    value,
    isLoading,
    isDisabled,
    isLimitReached,
    highlightedContactId,
    onHighlightEnd,
}: Props) => {
    if (value.length === 0 && !isDisabled) {
        return null;
    }

    if (value.length === 0 && isDisabled && !isLoading) {
        return (
            <Box>
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[250]}
                >
                    {translate("si.pages.ai_agent.form.keyAttendees.search.no_results_disabled")}
                </Text>
            </Box>
        );
    }

    return (
        <StyledContactCardsContainer>
            {value.map((contact, index) => (
                <ContactCard
                    key={contact.id}
                    contact={contact}
                    index={index}
                    isDisabled={isDisabled}
                    isLimitDisabled={isLimitReached && !contact.isSelected ? !isDisabled : false}
                    isHighlighted={contact.id === highlightedContactId}
                    onSelect={onSelect}
                    onHighlightEnd={onHighlightEnd}
                />
            ))}
        </StyledContactCardsContainer>
    );
};
